import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { getSign } from "@/utils/sign/sign";
import { downloadFile, getFileName } from "@/utils/download";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10 * 1000
});

service.interceptors.request.use(
  async config => {
    if (getToken()) {
      // 拿哈希
      const hash = window.location.hash;
      const parthash = hash.indexOf("?") === -1 ? hash : hash.split("?")[0];

      if (parthash !== "#/login" && `${store.state.user.id}` !== localStorage.getItem("id")) {
        if (!localStorage.getItem("id")) {
          setTimeout(() => {
            store.dispatch("user/resetToken").then(() => {
              sessionStorage.setItem("messageStatus", 0);
              location.reload();
            });
          }, 1000);
          return Promise.reject({ Error: "请重新登录" });
        } else {
          setTimeout(() => {
            location.hash = "#/merchant/index";
            location.reload();
          }, 1000);
          return Promise.reject({ Error: "用户已切换，1s后将自动刷新用户数据" });
        }
      }

      config.headers["Authorization"] = getToken();
      if (config.contentType) config.headers["Content-Type"] = config.contentType;
      config.exportFiles ? (config.responseType = "blob") : (config.responseType = "json");
    }
    if (!config.skipSign) {
      const S = await getSign(config.url);
      config.headers["Y-Sign"] = S.si;
      config.headers["Y-A"] = S.a;
      config.headers["Y-P"] = S.p;
      config.headers["Y-R"] = S.u;
    }
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  async response => {
    if (response.config.exportFiles) {
      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        let res;
        try {
          res = JSON.parse(text);
        } catch (e) {
          Message({
            message: "文件下载失败，解析错误",
            type: "error"
          });
          return Promise.reject(e);
        }
        Message({
          message: res.msg || "导出失败",
          type: "error"
        });

        return Promise.reject(res);
      }
      const fileName = getFileName(response.headers["content-disposition"]);
      downloadFile(response.data, contentType, fileName, response.config?.params?.messageTip);
      return { msg: "success" };
    }
    const res = response.data;
    if (res.code === 401) {
      Message({
        message: "请联系技术操作",
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(new Error("请联系技术操作"));
    }
    if (res.code !== 200) {
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      Message({
        message: res.msg || "系统异常，请稍后再试",
        type: "error",
        duration: 5 * 1000
      });
      // if (sessionStorage.getItem('messageStatus') !== '1') {
      //
      //   sessionStorage.setItem('messageStatus', 1)
      //   setTimeout(() => {
      //     sessionStorage.setItem('messageStatus', 0)
      //   }, 5000)
      // }
      if (res.code === 4001) {
        setTimeout(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        }, 1500);
      }
      return Promise.reject(new Error(res.msg || "系统异常，请稍后再试"));
    } else {
      sessionStorage.setItem("messageStatus", 0);
      return res;
    }
  },
  error => {
    if (sessionStorage.getItem("messageStatus") !== "1") {
      Message({
        message: error.Error || "系统异常，请稍后再试",
        type: "error",
        duration: 5 * 1000
      });
      sessionStorage.setItem("messageStatus", 1);
      setTimeout(() => {
        sessionStorage.setItem("messageStatus", 0);
      }, 3000);
    }
    return Promise.reject(error);
  }
);

export default service;
